var u = (h, r, e) => new Promise((g, n) => {
  var a = (i) => {
    try {
      t(e.next(i));
    } catch (o) {
      n(o);
    }
  }, s = (i) => {
    try {
      t(e.throw(i));
    } catch (o) {
      n(o);
    }
  }, t = (i) => i.done ? g(i.value) : Promise.resolve(i.value).then(a, s);
  t((e = e.apply(h, r)).next());
});
import { HOOK_PLUGIN_SETTINGS_SET as c } from "./const.js";
import { now as l } from "./time.js";
class S {
  constructor(r, e) {
    this.target = null, this.targetQueue = [], this.onQueue = [], this.plugin = r, this.hook = e;
    const g = {};
    if (r.settings)
      for (const s in r.settings) {
        const t = r.settings[s];
        g[s] = t.defaultValue;
      }
    const n = `__vue-devtools-plugin-settings__${r.id}`;
    let a = Object.assign({}, g);
    try {
      const s = localStorage.getItem(n), t = JSON.parse(s);
      Object.assign(a, t);
    } catch (s) {
    }
    this.fallbacks = {
      getSettings() {
        return a;
      },
      setSettings(s) {
        try {
          localStorage.setItem(n, JSON.stringify(s));
        } catch (t) {
        }
        a = s;
      },
      now() {
        return l();
      }
    }, e && e.on(c, (s, t) => {
      s === this.plugin.id && this.fallbacks.setSettings(t);
    }), this.proxiedOn = new Proxy({}, {
      get: (s, t) => this.target ? this.target.on[t] : (...i) => {
        this.onQueue.push({
          method: t,
          args: i
        });
      }
    }), this.proxiedTarget = new Proxy({}, {
      get: (s, t) => this.target ? this.target[t] : t === "on" ? this.proxiedOn : Object.keys(this.fallbacks).includes(t) ? (...i) => (this.targetQueue.push({
        method: t,
        args: i,
        resolve: () => {
        }
      }), this.fallbacks[t](...i)) : (...i) => new Promise((o) => {
        this.targetQueue.push({
          method: t,
          args: i,
          resolve: o
        });
      })
    });
  }
  setRealTarget(r) {
    return u(this, null, function* () {
      this.target = r;
      for (const e of this.onQueue)
        this.target.on[e.method](...e.args);
      for (const e of this.targetQueue)
        e.resolve(yield this.target[e.method](...e.args));
    });
  }
}
export {
  S as ApiProxy
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/@vue_devtools-api@6.6.4/~/@vue/devtools-api/lib/esm/proxy.js
// module id = 1364
// module chunks = 67